import { render, staticRenderFns } from "./TenderProject.vue?vue&type=template&id=4b09d22e"
import script from "./TenderProject.vue?vue&type=script&lang=js"
export * from "./TenderProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports